<app-size-detector></app-size-detector>

@for (field of fields; track field; let i = $index) {
  <div class="row no-gutters mt-4">
    <div class="col-11">
      <div class="row no-gutters">
        <!-- Field Name -->
        <div class="pr-1 col-sm">
          <mat-form-field class="single-field" appearance="fill">
            <mat-label>{{
              'references.add-new-reference-category.field-name-label'
              | translate
            }}</mat-label>
            <input
              matInput
              required
              [formControl]="field.name"
              placeholder="{{
                'references.add-new-reference-category.field-placeholder'
                  | translate
              }}"
              [readonly]="disabled || field.mandatory"
              />
              <mat-error>{{
                'references.add-new-reference-category.field-error-hint'
                | translate
              }}</mat-error>
            </mat-form-field>
          </div>
          <!-- Field Type -->
          <div class="pl-1 col-sm">
            <mat-form-field appearance="fill" class="single-field pr-sm-1">
              <mat-label>{{
                'references.add-new-reference-category.field-type-label'
                | translate
              }}</mat-label>
              <mat-select
              placeholder="{{
                'references.add-new-reference-category.field-type-placeholder'
                  | translate
              }}"
                required
                [formControl]="field.type"
                [disabled]="field.disableField || disabled || field.mandatory"
                (selectionChange)="onFieldTypeChange(i)"
                hideSingleSelectionIndicator="true"
                >
                @for (type of fieldTypesOptions; track type) {
                  <mat-option
                    [value]="type.value"
                    (click)="field.selectedCategory = null"
                    >
                    {{ type.key | titlecase }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        @if (collectKeyFromUser) {
          <div class="row no-gutters">
            <!-- Horizontal T lines -->
            @if (isDividersVisible) {
              <div class="col-1 mr-n2">
                <mat-divider class="horizontal-divider"></mat-divider>
                <mat-divider
                  vertical
                  class="vertical-divider"
            [ngClass]="{
              'vertical-divider--small':
                !field.additionalFormFields?.length && !hasDefaultValue(field)
            }"
                  >
                </mat-divider>
              </div>
            }
            <!-- Field Key -->
            <div class="col-sm pr-1">
              <mat-form-field class="single-field" appearance="fill">
                <mat-label>{{
                  'references.add-new-reference-category.field-key-label'
                  | translate
                }}</mat-label>
                <input
                  matInput
                  required
                  [formControl]="field.uniqueID"
              placeholder="{{
                'references.add-new-reference-category.field-key-placeholder'
                  | translate
              }}"
                  [disabled]="disabled || field.mandatory"
                  />
                  <mat-error>{{
                    'references.add-new-reference-category.field-key-error-hint'
                    | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          }
          <div class="row no-gutters">
            <!-- Horizontal T lines -->
            @if (
              (isBoolean(i) ||
              isReference(i) ||
              isCheckbox(i) ||
              isRadioButton(i)) &&
              isDividersVisible
              ) {
              <div
                class="col-1 mr-n2"
                >
                <mat-divider class="horizontal-divider"></mat-divider>
                <mat-divider
                  vertical
                  class="vertical-divider"
            [ngClass]="{
              'vertical-divider--small':
                !field.additionalFormFields?.length &&
                !hasDefaultValue(field) &&
                !isCheckbox(i) &&
                !isRadioButton(i),
              'vertical-divider--long': isReference(i) && screenSize.size < 3
            }"
                  >
                </mat-divider>
                @if (screenSize.size < 3) {
                  <mat-divider
                    class="horizontal-divider horizontal-divider--additional"
                  ></mat-divider>
                }
              </div>
            }
            <!-- Boolean type field labels -->
            @if (isBoolean(i)) {
              <div class="col-sm">
                <div class="row no-gutters">
                  <!-- True value label -->
                  <div class="col-sm">
                    <mat-form-field appearance="fill" class="single-field pr-sm-1">
                      <mat-label>{{
                        'configurable-fields.boolean.true-label' | translate
                      }}</mat-label>
                      <input
                        matInput
                        required
                        [formControl]="field.booleanLabels?.trueLabel"
                  [placeholder]="
                    'configurable-fields.boolean.true-label-placeholder'
                      | translate
                  "
                        [readonly]="disabled || field.mandatory"
                        (ngModelChange)="onBooleanLabelsPristine()"
                        />
                        @if (field.booleanLabels?.trueLabel?.hasError('required')) {
                          <mat-error
                            >{{
                            'configurable-fields.boolean.true-label-required'
                            | translate
                            }}</mat-error
                            >
                        }
                      </mat-form-field>
                    </div>
                    <!-- False value label -->
                    <div class="col-sm">
                      <mat-form-field appearance="fill" class="single-field pl-sm-1">
                        <mat-label>{{
                          'configurable-fields.boolean.false-label' | translate
                        }}</mat-label>
                        <input
                          matInput
                          required
                          [formControl]="field.booleanLabels?.falseLabel"
                  [placeholder]="
                    'configurable-fields.boolean.false-label-placeholder'
                      | translate
                  "
                          [readonly]="disabled || field.mandatory"
                          (ngModelChange)="onBooleanLabelsPristine()"
                          />
                          @if (field.booleanLabels?.falseLabel?.hasError('required')) {
                            <mat-error
                              >{{
                              'configurable-fields.boolean.false-label-required'
                              | translate
                              }}</mat-error
                              >
                          }
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }
                <!-- Reference Categories -->
                @if (isReference(i)) {
                  <div class="col-sm">
                    <div class="row no-gutters">
                      <!-- Reference Field Type -->
                      <div class="col-lg-6 reference-config-field">
                        <el-autocomplete
                          [selected]="field.reference_category.value"
                          [options]="referenceCategories"
                          [multiSelect]="false"
                          [hideTheAllOption]="true"
                [label]="
                  'references.add-new-reference-category.field-type-label'
                    | translate
                "
                          appearance="fill"
                          [required]="true"
                          [disabled]="disabled"
                          (itemsSelected)="onReferenceCategorySelected(i, $event)"
                          >
                        </el-autocomplete>
                      </div>
                      <!-- Reference Field Value -->
                      <div class="col-lg-6 reference-config-field">
                        <el-autocomplete
                          [selected]="field.reference_field.value"
                          [options]="field.referenceFieldsForSelectedCategory ?? []"
                          [multiSelect]="false"
                          [hideTheAllOption]="true"
                [label]="
                  'references.add-new-reference-category.reference-field-label'
                    | translate
                "
                          appearance="fill"
                          [required]="true"
                          [disabled]="!field.selectedCategory || disabled"
                          (itemsSelected)="setReferenceValues(i, $event)"
                          >
                        </el-autocomplete>
                      </div>
                    </div>
                  </div>
                }
                <!-- Add Checkbox Field Button-->
                @if (isCheckbox(i) || isRadioButton(i)) {
                  <div class="col-sm">
                    <button
                      mat-stroked-button
                      type="button"
                      class="mt-1 mb-4"
                      (click)="addNewRadioCheckboxOption(i)"
                      >
                      +&nbsp;Add Option
                    </button>
                  </div>
                }
              </div>
              <!-- Default value (for fields that aren't reference type) -->
              @if (hasDefaultValue(field)) {
                <div class="row no-gutters">
                  <!-- Horizontal T lines -->
                  @if (isDividersVisible) {
                    <div class="col-1 mr-n2">
                      <mat-divider class="horizontal-divider"> </mat-divider>
                      <mat-divider
                        vertical
                        class="vertical-divider"
            [ngClass]="{
              'vertical-divider--small':
                !field.additionalFormFields?.length && !isAdvanced(field)
            }"
                        >
                      </mat-divider>
                    </div>
                  }
                  <div
                    class="default-value col pl-sm-3 pl-xs-4"
                    [ngStyle]="dynamicStyles"
                    >
                    <app-display-single-configurable-field
                      [fieldItem]="field.displayTheDefaultFieldItem"
                      [disabled]="disabled"
                      [fields]="fields"
                      [disableUniqueFields]="true"
                    ></app-display-single-configurable-field>
                  </div>
                </div>
              }
              <!-- Checkbox Fields -->
              @if (isCheckbox(i)) {
                @for (
                  checkboxOption of field.checkboxOptions ?? []; track
                  checkboxOption; let idx = $index) {
                  <div
                    class="row no-gutters"
                    >
                    @if (isDividersVisible) {
                      <div class="col-sm-1 mr-n2">
                        <mat-divider class="horizontal-divider"></mat-divider>
                        <mat-divider vertical class="vertical-divider"></mat-divider>
                      </div>
                    }
                    <div class="col-sm-4">
                      <mat-form-field appearance="fill" class="single-field pr-sm-1">
                        <mat-label>Display Value</mat-label>
                        <input
                          type="text"
                          matInput
                          required
                          [formControl]="checkboxOption.displayValue"
                          />
                        </mat-form-field>
                      </div>
                      <div class="col-sm-4">
                        <mat-form-field appearance="fill" class="single-field pl-sm-1">
                          <mat-label>Value</mat-label>
                          <input
                            type="text"
                            matInput
                            required
                            [formControl]="checkboxOption.value"
                            />
                            @if (checkboxOption.value.hasError('required')) {
                              <mat-error>
                                {{ 'configurable-fields.value-required-error' | translate }}
                              </mat-error>
                            }
                            @if (checkboxOption.value.hasError('notUnique')) {
                              <mat-error>
                                {{ 'configurable-fields.value-unique-error' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-sm-2">
                          <mat-checkbox
                            color="accent"
                            class="m-3"
                            (change)="checkboxBehaviour($event, i, idx)"
                            [checked]="checkboxOption.checked"
              [disabled]="
                checkboxOption.displayValue.invalid ||
                checkboxOption.value.invalid
              "
                            >Default
                          </mat-checkbox>
                        </div>
                        <div class="col-sm">
                          <button
                            class="delete-btn"
                            mat-icon-button
                            type="button"
                            matTooltip="Delete"
                            [disabled]="(field.checkboxOptions ?? []).length < 2"
                            (click)="onClickDeleteCheckboxField(i, idx)"
                            >
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    }
                  }
                  <!-- Radio Button Fields -->
                  @if (isRadioButton(i)) {
                    @for (
                      radioButtonOption of field.radioButtonOptions ?? []; track
                      radioButtonOption; let idx = $index) {
                      <div
                        class="row no-gutters"
                        >
                        @if (isDividersVisible) {
                          <div class="col-sm-1 mr-n2">
                            <mat-divider class="horizontal-divider"></mat-divider>
                            <mat-divider vertical class="vertical-divider"></mat-divider>
                          </div>
                        }
                        <div class="col-sm-4">
                          <mat-form-field appearance="fill" class="single-field pr-sm-1">
                            <mat-label>Display Value</mat-label>
                            <input
                              type="text"
                              matInput
                              required
                              [formControl]="radioButtonOption.displayValue"
                              />
                            </mat-form-field>
                          </div>
                          <div class="col-sm-4">
                            <mat-form-field appearance="fill" class="single-field pl-sm-1">
                              <mat-label>Value</mat-label>
                              <input
                                type="text"
                                matInput
                                required
                                [formControl]="radioButtonOption.value"
                                />
                                @if (radioButtonOption.value.hasError('required')) {
                                  <mat-error>
                                    {{ 'configurable-fields.value-required-error' | translate }}
                                  </mat-error>
                                }
                                @if (radioButtonOption.value.hasError('notUnique')) {
                                  <mat-error>
                                    {{ 'configurable-fields.value-unique-error' | translate }}
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-sm-2">
                              <mat-radio-button
                                class="m-3"
                                [checked]="radioButtonOption.checked"
                                [name]="'default' + i"
                                (change)="radioButtonBehaviour(i, idx)"
              [disabled]="
                radioButtonOption.displayValue.invalid ||
                radioButtonOption.value.invalid
              "
                                >Default
                              </mat-radio-button>
                            </div>
                            <div class="col-sm">
                              <button
                                class="delete-btn"
                                mat-icon-button
                                type="button"
                                matTooltip="Delete"
                                [disabled]="(field.radioButtonOptions ?? []).length < 2"
                                (click)="onClickDeleteRadioButtonField(i, idx)"
                                >
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </div>
                        }
                      }
                      @if (isAdvanced(field)) {
                        <div class="row no-gutters">
                          <!-- Horizontal T lines -->
                          @if (isDividersVisible) {
                            <div class="col-1 mr-n2">
                              <mat-divider class="horizontal-divider"></mat-divider>
                              <mat-divider vertical class="vertical-divider"></mat-divider>
                            </div>
                          }
                          <!-- Field Layout -->
                          <div class="col pl-4 pl-sm-0">
                            <mat-form-field appearance="fill" class="single-field">
                              <mat-label>{{
                                'references.add-new-reference-category.layout-label' | translate
                              }}</mat-label>
                              <mat-select
              placeholder="{{
                'references.add-new-reference-category.layout-placeholder'
                  | translate
              }}"
                                required
                                [formControl]="field.layout"
                                hideSingleSelectionIndicator="true"
                                >
                                @for (type of fieldWidthOptions; track type) {
                                  <mat-option
                                    [value]="type.value"
                                    >
                                    {{ type.key | titlecase }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      }
                      <!-- Regex field section -->
                      @if (isText(i) && isAdvanced(field)) {
                        <div class="row no-gutters mb-3">
                          <!-- Horizontal T lines -->
                          @if (isDividersVisible) {
                            <div class="col-1 mr-n2">
                              <mat-divider class="horizontal-divider"></mat-divider>
                              <mat-divider
                                vertical
                                class="vertical-divider vertical-divider--long"
                              ></mat-divider>
                            </div>
                          }
                          <div class="col-sm">
                            <div class="row no-gutters mb-2">
                              <div class="col-8">
                                <!-- Regular Expression -->
                                <mat-form-field
                                  appearance="fill"
                                  id="regex-expression-field"
                                  class="single-field"
                                  >
                                  <mat-label>Regular Expressions</mat-label>
                                  <input
                                    type="text"
                                    matInput
                                    name="regex{(i)}"
                                    (change)="field.regexField?.regexType?.setValue('custom')"
                                    [formControl]="field.regexField?.regex"
                                    placeholder="[A-Za-z0-9]"
                                    />
                                    <mat-hint
                                      >Do not add the beginning and ending slashes of the regular
                                      expression</mat-hint
                                      >
                                      @if (field.regexField?.regex.hasError('invalidRegex')) {
                                        <mat-error
                                          >Regular expression is invalid</mat-error
                                          >
                                      }
                                      @if (isDividersVisible) {
                                        <mat-divider
                                          matSuffix
                                          [vertical]="true"
                                          class="form-suffix-divider"
                                        ></mat-divider>
                                      }
                                    </mat-form-field>
                                  </div>
                                  <div class="col-4">
                                    <!-- Regular Expression Type -->
                                    <mat-form-field
                                      id="regex-type-field"
                                      matSuffix
                                      appearance="fill"
                                      class="single-field"
                                      >
                                      <mat-label>Regex Type</mat-label>
                                      <mat-select
                                        [formControl]="field.regexField?.regexType"
                                        (selectionChange)="onRegexTypeChange($event.value, i)"
                                        hideSingleSelectionIndicator="true"
                                        >
                                        <mat-option value="email">Email</mat-option>
                                        <mat-option value="custom">Custom</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          <!-- Additional fields -->
                          @if (
                            field?.additionalFormFields && field?.additionalFormFields?.length > 0
                            ) {
                              @for (
                                additionalField of field?.additionalFormFields; track
                                additionalField; let j = $index) {
                                <div class="row no-gutters">
                                  @if (isDividersVisible) {
                                    <div class="col-1 mr-n2">
                                      <mat-divider class="horizontal-divider"></mat-divider>
                                      <mat-divider
                                        vertical
                                        class="vertical-divider"
                                        [ngClass]="{
                                          'vertical-divider--small':
                                            j === (field.additionalFormFields?.length ?? 0) - 1
                                        }"
                                      ></mat-divider>
                                    </div>
                                  }
                                  <div class="col-sm">
                                    <mat-form-field
                                      appearance="fill"
                                      class="single-field ref-fields-form-field"
                                    >
                                      <mat-label>{{ additionalField.label }}</mat-label>
                                      @if (additionalField.type === 'TEXT') {
                                        <input
                                          type="text"
                                          matInput
                                          [name]="additionalField.key"
                                          [required]="additionalField.isRequired"
                                          [formControl]="additionalField.field"
                                          [placeholder]="additionalField.placeholder"
                                          [disabled]="additionalField.isDisabled"
                                        />
                                      }
                                      @if (additionalField.type === 'DROPDOWN') {
                                        <mat-select
                                          [placeholder]="additionalField.placeholder"
                                          [required]="additionalField.isRequired"
                                          [formControl]="additionalField.field"
                                          [disabled]="additionalField.isDisabled"
                                          (selectionChange)="
                                            onAdditionalFieldSelectionChanged($event.value, i, j)
                                          "
                                          hideSingleSelectionIndicator="true"
                                        >
                                          @for (option of additionalField.options; track option) {
                                            <mat-option [value]="option.value">
                                              {{ option.value | titlecase }}
                                            </mat-option>
                                          }
                                        </mat-select>
                                      }
                                      <mat-error>{{ additionalField.errorMessage }}</mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                              }
                          }
                          <!-- Add Criteria section -->
                          @if (isAdvanced(field)) {
                            <div class="row no-gutters">
                              <!-- Horizontal T lines -->
                              @if (isDividersVisible) {
                                <div class="col-1 mr-n2">
                                  <mat-divider class="horizontal-divider"></mat-divider>
                                  <mat-divider
                                    vertical
                                    class="vertical-divider"
            [ngClass]="{
              'vertical-divider--small': !field.criteria?.length
            }"
                                    >
                                  </mat-divider>
                                </div>
                              }
                              <div class="col-sm mt-1 mb-4">
                                <button type="button" mat-stroked-button (click)="addNewCriteria(i)">
                                  +&nbsp;Add Criteria
                                </button>
                              </div>
                            </div>
                          }
                          @if (isAdvanced(field)) {
                            <div class="row no-gutters">
                              <div class="col">
                                @for (criteria of field.criteria ?? []; track criteria; let idx = $index) {
                                  <div class="row no-gutters">
                                    <!-- Horizontal T lines -->
                                    @if (isDividersVisible) {
                                      <div class="col-sm-1 mr-n2">
                                        <mat-divider class="horizontal-divider"></mat-divider>
                                        <mat-divider
                                          vertical
                                          class="vertical-divider vertical-divider--small"
                  [ngClass]="{
                    'vertical-divider--long':
                      idx < (field.criteria?.length ?? 0) - 1
                  }"
                                          >
                                        </mat-divider>
                                      </div>
                                    }
                                    <div class="col-sm">
                                      <div class="row no-gutters">
                                        <div class="col-11">
                                          <div class="row no-gutters">
                                            <!-- Criteria Type -->
                                            <div class="col-6">
                                              <mat-form-field
                                                appearance="fill"
                                                class="single-field pr-sm-1"
                                                >
                                                <mat-label>Criteria Type</mat-label>
                                                <mat-select
                                                  placeholder="Criteria Type"
                                                  required
                                                  [formControl]="criteria.criteria"
                                                  hideSingleSelectionIndicator="true"
                                                  >
                                                  @for (type of getCriteriaTypes(i); track type) {
                                                    <mat-option
                                                      [value]="type.value"
                                                      >
                                                      {{ type.key | titlecase }}
                                                    </mat-option>
                                                  }
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                            <!-- Dependent Field -->
                                            <div class="col-6">
                                              <mat-form-field
                                                appearance="fill"
                                                class="single-field pl-sm-1"
                                                >
                                                <mat-label>Dependent Field</mat-label>
                                                @if (isReference(i)) {
                                                  <mat-select
                                                    placeholder="Dependent Field"
                                                    required
                                                    [formControl]="criteria.dependent_field"
                                                    (selectionChange)="dependentFieldChange()"
                                                    hideSingleSelectionIndicator="true"
                                                    >
                                                    @for (
                                                      dependent_field of getDependentFields(i); track
                                                      dependent_field; let dependent_field_index = $index) {
                                                      <mat-option
                                                        [value]="dependent_field.uniqueID.value"
                                                        >
                                                        {{ dependent_field.name.value }}
                                                      </mat-option>
                                                    }
                                                  </mat-select>
                                                }
                                                @if (!isReference(i)) {
                                                  <mat-select
                                                    placeholder="Dependent Field"
                                                    required
                                                    [formControl]="criteria.dependent_field"
                            (selectionChange)="
                              dependentFieldChange();
                              criteria.compare_value.setValue('')
                            "
                                                    hideSingleSelectionIndicator="true"
                                                    >
                                                    @for (
                                                      _field of getDependentFields(i); track
                                                      _field; let depFieldIndex = $index) {
                                                      <mat-option
                                                        [value]="_field.uniqueID.value"
                                                        >
                                                        {{ _field.name.value }}
                                                      </mat-option>
                                                    }
                                                  </mat-select>
                                                }
                                              </mat-form-field>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-1">
                                          <button
                                            type="button"
                                            class="delete-btn"
                                            mat-icon-button
                                            (click)="onClickDeleteCriteria(i, idx)"
                                            >
                                            <mat-icon>delete</mat-icon>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="row no-gutters">
                                        <!-- L shape dividers -->
                                        @if (isDividersVisible) {
                                          <div class="col-sm-1 mr-n2">
                                            <mat-divider class="horizontal-divider"></mat-divider>
                                            <mat-divider
                                              vertical
                                              class="vertical-divider vertical-divider--small"
                                              >
                                            </mat-divider>
                                          </div>
                                        }
                                        <div
                    [ngStyle]="{
                      width:
                        criteria.compare_with?.value === 'DIRECT'
                          ? '30%'
                          : '45%'
                    }"
                                          >
                                          <!-- Compare With -->
                                          <mat-form-field
                                            appearance="fill"
                                            class="single-field--fill pr-sm-1"
                                            >
                                            <mat-label>Compare With</mat-label>
                                            <mat-select
                                              placeholder=""
                                              required
                                              [formControl]="criteria.compare_with"
                                              hideSingleSelectionIndicator="true"
                                              >
                                              @for (compareType of getCriteriaCompareTypes(i); track compareType) {
                                                <mat-option
                                                  [value]="compareType.value"
                                                  >
                                                  {{ compareType.key | titlecase }}
                                                </mat-option>
                                              }
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        @if (criteria.compare_with?.value === 'DIRECT') {
                                          <div
                                            style="width: 30%"
                                            >
                                            <!-- Comparator -->
                                            <mat-form-field
                                              appearance="fill"
                                              class="single-field--fill pr-sm-1"
                                              >
                                              <mat-label>Comparator</mat-label>
                                              <mat-select
                                                placeholder="Comparator"
                                                required
                                                [formControl]="criteria.comparator"
                                                hideSingleSelectionIndicator="true"
                                                >
                                                @for (
                                                  comparator of getComparisonTypes(
                                                  criteria.dependent_field.value
                                                  )
                                                  ; track
                                                  comparator) {
                                                  <mat-option
                                                    [value]="comparator.value"
                                                    >
                                                    {{ comparator.key }}
                                                  </mat-option>
                                                }
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                        }
                                        <!-- Compare Value -->
                                        <div
                    [ngStyle]="{
                      width:
                        criteria.compare_with?.value === 'DIRECT'
                          ? '30%'
                          : '45%'
                    }"
                                          >
                                          <!-- empty compare value field -->
                                          @if (
                                            !getDependentFieldType(criteria.dependent_field.value)
                                            ) {
                                            <mat-form-field
                                              appearance="fill"
                                              class="single-field--fill"
                                              >
                                              <mat-label>Compare Value</mat-label>
                                              <mat-select
                                                placeholder="Compare Value"
                                                required
                                                [formControl]="criteria.compare_value"
                                                [disabled]="true"
                                                hideSingleSelectionIndicator="true"
                                                >
                                                <mat-option></mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          }
                                          @if (
                                            getDependentFieldType(
                                            criteria.dependent_field.value
                                            ) === fieldTypes.REFERENCES
                                            ) {
                                            @if (isReference(i)) {
                                              <mat-form-field
                                                appearance="fill"
                                                class="single-field--fill"
                                                >
                                                <mat-label>Compare Value</mat-label>
                                                <mat-select
                                                  placeholder="Compare Value"
                                                  required
                                                  [formControl]="criteria.compare_value"
                                                  hideSingleSelectionIndicator="true"
                                                  >
                                                  @for (
                                                    comparable_field of field.selectedCategory
                                                    ?.fields
                                                    ; track
                                                    comparable_field) {
                                                    <mat-option
                                                      [value]="comparable_field._id"
                                                      >
                                                      {{ comparable_field?.name }}
                                                    </mat-option>
                                                  }
                                                </mat-select>
                                              </mat-form-field>
                                            }
                                            @if (!isReference(i)) {
                                              <mat-form-field
                                                appearance="fill"
                                                class="single-field--fill"
                                                >
                                                <mat-label>Compare Value</mat-label>
                                                <!-- get dependent field's references -->
                                                <mat-select
                                                  placeholder="Compare Value"
                                                  required
                                                  [formControl]="criteria.compare_value"
                                                  hideSingleSelectionIndicator="true"
                                                  >
                                                  @for (
                                                    referenceValues of getDependentReferenceFieldValues(
                                                    criteria.dependent_field.value
                                                    )
                                                    ; track
                                                    referenceValues) {
                                                    <mat-option
                                                      [value]="referenceValues.value"
                                                      >
                                                      {{ referenceValues.displayValue }}
                                                    </mat-option>
                                                  }
                                                </mat-select>
                                              </mat-form-field>
                                            }
                                          }
                                          @if (
                                            getDependentFieldType(
                                            criteria.dependent_field.value
                                            ) === fieldTypes.NUMBER
                                            ) {
                                            <mat-form-field
                                              appearance="fill"
                                              class="single-field--fill"
                                              >
                                              <mat-label>Compare Value</mat-label>
                                              <input
                                                type="number"
                                                matInput
                                                [formControl]="criteria.compare_value"
                                                />
                                              </mat-form-field>
                                            }
                                            @if (
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.CHECKBOX ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.RADIO_BUTTON
                                              ) {
                                              <!-- Because both radio and checkbox options should be shown as dropdown elements here -->
                                              <!-- So, cannot use the display-configurable-field normal flow here -->
                                              <mat-form-field
                                                appearance="fill"
                                                class="single-field--fill"
                                                >
                                                <mat-label>Compare Value</mat-label>
                                                <mat-select
                                                  placeholder="Compare Value"
                                                  required
                                                  [formControl]="criteria.compare_value"
                                                  hideSingleSelectionIndicator="true"
                                                  >
                                                  @for (
                                                    comparable_field of getComparableFields(
                                                    i,
                                                    idx
                                                    )
                                                    ; track
                                                    comparable_field) {
                                                    <mat-option
                                                      [value]="comparable_field.value?.value"
                                                      >
                                                      {{ comparable_field.displayValue?.value }}
                                                    </mat-option>
                                                  }
                                                </mat-select>
                                              </mat-form-field>
                                            }
                                            @if (
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.TEXT ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.CURRENCY ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.DATE ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.DATE_TIME ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.ADDRESS ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.NAME ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.CONTACT_NUMBER ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.EMAIL ||
                                              getDependentFieldType(
                                              criteria.dependent_field.value
                                              ) === fieldTypes.BOOLEAN
                                              ) {
                                              <app-display-single-configurable-field
                                                id="display-config-field"
                        [fieldItem]="
                          getCompareValueField(
                            criteria.compare_value,
                            criteria.dependent_field.value
                          )
                        "
                                              ></app-display-single-configurable-field>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                          <!-- Delete Field button -->
                          <div class="col-1">
                            <button
                              class="pt-1"
                              style="margin-top: 8px"
                              mat-icon-button
                              (click)="removeForm(i)"
                              type="button"
                              matTooltip="Delete"
                              [disabled]="field.disableField || disabled || field.mandatory"
                              >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                        <!-- Checkboxes -->
                        <div class="col-11">
                          <div class="field-config-checkboxes">
                            @for (checkBox of field?.checkboxes; track checkBox; let j = $index) {
                              @if (checkBox && checkBox?.key) {
                                <mat-checkbox
                                  color="accent"
                                  (change)="onCheckClicked(i, j)"
                                  [checked]="checkBox.isChecked"
                                  class="checkbox"
                                  [disabled]="
                                    disabled ||
                                    isCheckboxDisabled(i, j, field) ||
                                    checkBox.disabled ||
                                    field.disableField
                                  "
                                >
                                  {{ checkBox.key }}
                                </mat-checkbox>
                              }
                            }
                          </div>
                        </div>
                      }

                      @if (fields && fields.length === 0) {
                        <div>
                          <app-no-results-found></app-no-results-found>
                        </div>
                      }
